import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//

import Drip from 'drip';
export default {
  name: 'go-order-page',
  props: {},
  data: function data() {
    return {
      sellChannel: (Drip.constant || {}).appType,
      isNative: Drip.UA.isNative
    };
  },
  mounted: function mounted() {
    var IS_WXAPP_MEITUAN_PINCHANG = window.Drip && window.Drip.UA.IS_WXAPP_MEITUAN_PINCHANG;
    if (IS_WXAPP_MEITUAN_PINCHANG) {
      // 【美团休娱-拼场小程序】演出详情页的“订单”按钮建议隐藏掉，否则会看到该账号下微信小程序端的订单记录
      this.isNative = true;
    }
  },
  methods: {
    goOrder: function goOrder() {
      if (Drip.UA.IS_MAIDANBA) {
        this.$router.replace('/order-list');
      } else if (Drip.UA.IS_CMBAPP) {
        var _Drip$redirect;
        var redirUrl = (_Drip$redirect = Drip.redirect) === null || _Drip$redirect === void 0 ? void 0 : _Drip$redirect.getUrl('/myshow/#/order-list');
        location.href = redirUrl;
      } else {
        Drip.redirect('/myshow/#/order-list');
      }
    }
  }
};